import NumberFormat from 'react-number-format';
import React from 'react';

// not including ref argument results in a console warning
/* eslint no-unused-vars: ["error", { "args": "none" }] */
const CurrencyMask = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      decimalScale={2}
      thousandSeparator
    />
  );
});

export default CurrencyMask;
